// removed by extract-text-webpack-plugin
module.exports = {"memberModerationReferences":"References__memberModerationReferences___1aMcd","header":"References__header___3nETC","references":"References__references___7dKk9"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/admin/memberModeration/components/references/References.scss
// module id = 1716
// module chunks = 0